import React, { useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import styles from '../../Global/emailSubscriberForm/emailSubscriberForm.module.css';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'gatsby';

export default function EmailSubscriberForm({ CTA, newsletterTitle, newsletterText }) {
	const [ email, setEmail ] = useState('');
	const [ checkbox, setCheckbox ] = useState(false);
	const [ submissionMessege, setSubmissionMessege ] = useState('');
	const [ submissionSuccesful, setSubmissionSuccesful ] = useState(false);

	const displaySubmissionMessege = () => {
		if (submissionMessege === 'Thank you for subscribing!') {
			return 'Thank you for subscribing! 🎉  We just sent you a welcome discount coupon that gives you 10% off your next order with us ❤️';
		} else if (submissionMessege.includes('already')) {
			return 'You have subscribed to this newsletter already. Thank you once again 😊';
		} else {
			return submissionMessege;
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (checkbox === true) {
			addToMailchimp(email)
				.then((data) => {
					setSubmissionMessege(data.msg);
					setEmail('');
					setCheckbox(!checkbox);
					setSubmissionSuccesful(data.msg === 'Thank you for subscribing!' ? true : false);
				})
				.catch((errors) => {
					setSubmissionMessege(
						<p>
							Uhoh, I cant register this email due to some reason. Maybe there is a typo
							<span role="img" aria-label="thinking emoji">
								🤔
							</span>
						</p>
					);
					setEmail('');
					setCheckbox(!checkbox);
				});
		} else {
			setSubmissionMessege(
				<p className={styles.checkboxReminder}>
					Please agree to share your data{' '}
					<span role="img" aria-label="smiling emoji">
						😊
					</span>
				</p>
			);
		}
	};
	return (
		<section>
			<Row className={styles.form}>
				<Col xs={11} md={11} className={styles.content}>
					<Row className={styles.contentRow}>
						<Col xs={12} md={8} lg={6}>
							<h2>{newsletterTitle}</h2>
							<p>{newsletterText}</p>
							{!submissionSuccesful && (
								<span>
									<form onSubmit={handleSubmit}>
										<label htmlFor="email address" className={styles.label}>
											<p>{CTA}</p>
										</label>
										<input
											id="email address"
											type="email"
											placeholder="Email Address"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											className={styles.input}
										/>
									</form>

									<span className={styles.checkbox}>
										<input
											type="checkbox"
											onChange={() => setCheckbox(!checkbox)}
											name="checkbox for GDPR compliance"
											value={checkbox}
											checked={checkbox}
											required
											id="checkbox for GDPR compliance"
											className={styles.checkbox}
										/>
										<label htmlFor="checkbox for GDPR compliance" className={styles.label}>
											<p className={styles.disclaimer}>
												By subscribing, you grant us permission to send you further
												correspondence. For more information, please visit our
												<Link className={styles.privacyPolicy} to="privacypolicy">
													privacy policy
												</Link>.
											</p>
										</label>
									</span>
									<button onClick={handleSubmit} className={styles.button} disabled={!checkbox}>
										{!checkbox ? 'CHECK THE BOX' : 'SUBMIT'}
									</button>
								</span>
							)}
						</Col>
						<Col xs={12}>
							<p className={styles.submissionMessege}>{displaySubmissionMessege()}</p>
						</Col>
					</Row>
				</Col>
			</Row>
		</section>
	);
}
